
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
	selector: 'ad-dashboard',
	templateUrl: './ad-dashboard.component.html',
	styleUrls: ['./ad-dashboard.component.scss']
})

export class AdDashboardComponent implements OnInit, OnDestroy {
	activeTab: 'outstream' | 'instream' | 'adschedules' = 'outstream';

	private subscriptions: Subscription = new Subscription();

	constructor(private route: ActivatedRoute) { }

	ngOnInit(): void {
		this.subscriptions.add(this.route.params.subscribe((params: Params) => {
			if (params) {
				if (this.activeTab !== params.tab) {
					this.activeTab = params.tab;
				}
			}
		}));
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
